<template>
  <div class="access-forbidden-container">
    <div class="messageContent">
      <div class="messageType">
        <span
          v-if="code == '401' || code == '403' || code == '499'"
          class="scf-padlock"
          style="color: ##77b7fc"
        ></span>
      </div>
      <div class="messageBlock">
        <span class="politeForm"
          >{{ $t("errors.politeForm" + code) }}...&nbsp;</span
        >
        <span class="message">{{ $t("errors." + code) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "error-vue",
  props: {
    code: {
      type: String,
      default: "500",
    },
  },
};
</script>

<style scoped>
.access-forbidden-container {
  text-align: center;
  padding: 10%;
}
.access-forbidden-title {
  color: brown;
}
.messageBlock {
  display: flex;
  /* flex-direction: row; */
  margin-top: 20px;
  /* text-align: center; */
  flex-direction: row;
  justify-content: center;
}

.messageContent {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.politeForm {
  font-family: "D-DIN" !important;
  font-style: normal;
  font-weight: 900;
  font-size: 32px;
  line-height: 32px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #77b7fc;
  flex: none;
  order: 1;
  align-self: stretch;
}
.message {
  height: 32px;
  font-family: "D-DIN" !important;
  font-style: normal;
  font-weight: 900;
  font-size: 32px;
  line-height: 32px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #030f40;
  flex: none;
  order: 1;
  align-self: stretch;
}

.messageType {
  height: 128px;
  font-family: "D-DIN" !important;
  font-style: normal;
  font-weight: 900;
  font-size: 128px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  color: #77b7fc;
}
</style>
